import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFire} from "../DumpsterFire";
import {ISymbol} from "../../core/reel/simplereel/IReelData";
import {TimelineLite} from "gsap";
import {DumpsterFireSymbol, SYMBOL_NAME} from "../reels/DumpsterFireSymbol";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class InfectiousXWaysRunner implements SimplePresentation {
    private _tl: TimelineLite = new TimelineLite();

    shouldRun(): boolean {
        return DumpsterFire.model.explodeXIPos.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            delay: 0.001,
            onStart: () => {
                this._tl.add(DumpsterFire.reelAnticipation.hideContainer(), 0);
            },
            onComplete: () => {
                DumpsterFire.model.isNotNoWinRound = true;
                if (DumpsterFire.model.data.scatterWins.length === 0 && !DumpsterFire.model.isXBombPresent) {
                    DumpsterFire.allReelsView.removeWinMulti();
                    DumpsterFire.winMultiView.removeAllSprites();
                }
                this._tl.kill();
                controller.finish();
            }
        });
        const tl: TimelineLite = new TimelineLite();
        let multiValue: number = 0,
            symbolNumber: number = 0;
        this._tl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
        }, 0.001);
        for (let i: number = 0; i < DumpsterFire.model.explodeXIPos.length; i++) {
            const reelId: number = Math.floor(DumpsterFire.model.explodeXIPos[i] / 6),
                rowId: number = DumpsterFire.model.explodeXIPos[i] % 6,
                symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, rowId),
                toSymbol: string = DumpsterFire.model.gameData.evaluatedReels[reelId][rowId];
            multiValue = DumpsterFire.model.data.xWaysMultipliers[reelId][rowId];
            let prevMultiPosValue: number = DumpsterFire.preMultiPosArray[reelId][rowId];
            tl.add([DumpsterFire.xInfectiousWaysView.playInfectiousXWaysAnimation(reelId, rowId),
            ]);
            tl.add([(<DumpsterFireSymbol>symbol).changeSymbol(toSymbol as SYMBOL_NAME),
                DumpsterFire.allReelsView.showWinMultipliers(reelId, rowId, multiValue * prevMultiPosValue),
                DumpsterFire.bgMulti.showMultipliers(reelId, rowId, multiValue * prevMultiPosValue),
                DumpsterFire.bgFinalMulti.showFinalMultipliers(reelId, rowId, multiValue * prevMultiPosValue),
                () => {
                    DumpsterFire.soundPlayer.getXFeatureMultiSound(multiValue * prevMultiPosValue);
                }
            ], "<0.2");
            tl.add([() => {
                if (DumpsterFire.model.checkXIExpansion()) {
                    DumpsterFire.soundPlayer.playSound(DumpsterFireSound.XI_START);
                }
            }, DumpsterFire.allReelsView.infectedSymbol(multiValue, prevMultiPosValue, symbolNumber, reelId, rowId, i)], "<0.2");
            tl.add(() => {
                if (DumpsterFire.model.checkXIExpansion()) {
                    DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.XI_START);
                    DumpsterFire.soundPlayer.playSound(DumpsterFireSound.XI_STOP);
                }
            }, "<1.0");
            symbolNumber++;
            tl.to(this, {duration: 0.02});
        }
        this._tl.add(tl, 0);
        this._tl.to(this, {duration: 0.001});
    }

    private onSkip(): void {
        this._tl.timeScale(2);
    }
}